import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CloudOff } from "lucide-react";
import { Button } from "../../../components/ui/button";
import { StepHeader } from "../../../components/kiosk/StepHeader";
import { StepProgress } from "../../../components/kiosk/StepProgress";

export default function OfflineQueuedStep({ visitorName, hostName, purpose }) {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(12);

  useEffect(() => {
    if (countdown <= 0) {
      navigate("/kiosk");
      return;
    }
    const t = setTimeout(() => setCountdown((c) => c - 1), 1000);
    return () => clearTimeout(t);
  }, [countdown, navigate]);

  return (
    <div className="max-w-md mx-auto space-y-6 text-center" data-testid="offline-queued-step">
      <StepProgress current="badge" />
      <StepHeader
        icon={CloudOff}
        title="Saved — Pending Sync"
        subtitle="No internet connection right now. This check-in is saved on this tablet and will sync automatically once reconnected."
      />
      <div className="bg-white border border-amber-300 shadow-sm rounded-lg p-6 space-y-3">
        <p className="text-2xl font-black uppercase tracking-tight text-brand-navy" data-testid="offline-queued-visitor-name">
          {visitorName}
        </p>
        <p className="text-sm text-slate-500">
          Visiting <span className="font-semibold text-brand-navy">{hostName}</span> — {purpose}
        </p>
        <div className="bg-amber-50 border border-amber-300 rounded-md py-2 px-3" data-testid="offline-not-screened-warning">
          <p className="text-xs font-bold uppercase tracking-widest text-amber-700">Not yet screened against watchlist</p>
          <p className="text-xs text-amber-600 mt-1">Watchlist/blacklist check will run automatically when this syncs.</p>
        </div>
      </div>
      <Button onClick={() => navigate("/kiosk")} data-testid="offline-queued-done-button" className="w-full h-14 rounded-sm bg-brand-navy text-white hover:bg-brand-navy-light font-bold uppercase text-lg">
        Done
      </Button>
      <p className="text-xs text-slate-400" data-testid="offline-queued-countdown">
        Returning home in {countdown}s
      </p>
    </div>
  );
}
